import { redirectTo } from 'assets/core/js/module/redirect'

export const decodeSeoLinkHref = (el: Element): string | null => {
  const encoded = el.getAttribute('data-seo-link-href')

  return encoded !== null ? atob(encoded) : null
}

function initialize(): void {
  document.body.addEventListener(
    'click',
    (event: MouseEvent) => {
      const target = event.target as HTMLElement
      const button = target.closest('[data-seo-link-href]')

      if (button === null) {
        return
      }

      // Ignored links are useful to keep obfuscation while allowing custom
      // scripts to handle click events.
      const ignored = button.getAttribute('data-seo-link-ignored')
      if (ignored === 'ignored') {
        return
      }

      const decoded = decodeSeoLinkHref(button)
      if (decoded !== null) {
        /** Handle the case where the link is set as external. */
        if (button.classList.contains('external-link')) {
          try {
            event.preventDefault()
            event.stopPropagation()

            const windowOpen = window.open()
            if (windowOpen) {
              windowOpen.opener = null
              windowOpen.location.assign(decoded)

              return
            }
          } catch (exception) {
            console.error(exception)
          }
        }
        redirectTo(decoded)
      }
      /** We listen to the event in the capture phase to catch it before the click listener in core/common. */
    },
    true
  )
}

export default (): void => {
  initialize()
}
